export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "lutrijabihlive-themeWrap" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "lutrijabihlive-themeWrap" */'./LiveThemeImporter'),
  },
};
